import { useEffect, useState } from "react";

import ReactLoading from "react-loading";
import { useParams } from "react-router";

import { LanguageSelector } from "components/LanguageSelector";

import kentaLogo from "assets/KENTA_4.0.png";

import api from "services/api";

import { Container, Content, LogoContainer, LanguageSelectorWrapper, Subtitle } from "./styles";

const InviteRoomResult = () => {
  const [loadingInviteRoom, setLoadingInviteRoom] = useState(true);
  const [message, setMessage] = useState("");
  const { token } = useParams();

  useEffect(() => {
    onLoad();
  }, []);

  async function onLoad() {
    try {
      const result = await api.get(`/v1/HearingInviteRoom/Validate?token=${token}`);
      setLoadingInviteRoom(false);
      window.location.href = result.data;
    } catch (error: any) {

      setMessage(error?.response?.data || "Erro ao validar o token");
      setLoadingInviteRoom(false);
    }
  }

  return (
    <Container>
      <LanguageSelectorWrapper>
        <LanguageSelector />
      </LanguageSelectorWrapper>
      <Content>
        <LogoContainer>
          <img src={kentaLogo} alt="Logo da Empresa" width={240} height={90} />
        </LogoContainer>
        {loadingInviteRoom ? (
          <ReactLoading type="spin" color="#F2A60D" width={24} height={24} />
        ) : (
          <>
            <Subtitle>Atenção</Subtitle>
            <p>{message}</p>
          </>
        )}
      </Content>
    </Container>
  );
};

export default InviteRoomResult;
